// src/components/MeusPedidos.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import PedidoStatus from "../../componentes-frete/PedidoStatus";
import { getPedidosByUsuarioIdRoyal } from "../../componentes-frete/PedidoStatusApi";

export default function MeusPedidos({ showPedidos, setShowPedidos, windowDimensions, setShowUser }) {
  const navigate = useNavigate();

  const [pedidos, setPedidos] = useState([]);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [loadingPedidos, setLoadingPedidos] = useState(false);
  const [erroPedidos, setErroPedidos] = useState("");

  useEffect(() => {
    let mounted = true;

    async function loadPedidos() {
      if (!showPedidos) return;

      try {
        setLoadingPedidos(true);
        setErroPedidos("");

        const usuario = JSON.parse(localStorage.getItem("usuario"));
        const usuario_id = usuario?.usuario_id;

        if (!usuario_id) {
          throw new Error("Usuário não encontrado");
        }

        const data = await getPedidosByUsuarioIdRoyal(usuario_id);

        if (mounted) {
          setPedidos(data.pedidos || []);
        }
      } catch (error) {
        if (mounted) {
          setErroPedidos(error.message || "Erro ao carregar pedidos");
        }
      } finally {
        if (mounted) {
          setLoadingPedidos(false);
        }
      }
    }

    loadPedidos();

    return () => {
      mounted = false;
    };
  }, [showPedidos]);

  if (!showPedidos) return null;

  return windowDimensions.width < 696 ? (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 100001,
        background: "#ffffff",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          height: 48,
          position: "sticky",
          top: 0,
          backgroundColor: "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
        }}
      >
        <h2 style={{ margin: 0, color: "white", fontSize: "1.05rem" }}>
          {pedidoSelecionado ? "Status do Pedido" : "Meus Pedidos"}
        </h2>

        <FaArrowLeft
          onClick={() => {
            if (pedidoSelecionado) {
              setPedidoSelecionado(null);
            } else {
              setShowPedidos(false);
            }
          }}
          style={{
            position: "absolute",
            top: 14,
            left: 12,
            cursor: "pointer",
            color: "white",
            fontSize: 16,
          }}
        />
      </div>

      <div
        style={{
          background: "#f8fafc",
          padding: "0.85rem",
          borderRadius: 12,
          boxShadow: "0 6px 18px rgba(17,24,39,0.04)",
          width: "100%",
          maxWidth: 720,
          margin: "1rem auto",
          boxSizing: "border-box",
        }}
      >
        {!pedidoSelecionado ? (
          <>
            {loadingPedidos ? (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: "20px 14px",
                  textAlign: "center",
                  color: "#6b7280",
                  boxShadow: "0 4px 14px rgba(17,24,39,0.05)",
                }}
              >
                Carregando pedidos...
              </div>
            ) : erroPedidos ? (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: "20px 14px",
                  textAlign: "center",
                  color: "red",
                  boxShadow: "0 4px 14px rgba(17,24,39,0.05)",
                }}
              >
                {erroPedidos}
              </div>
            ) : pedidos?.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                {pedidos.map((pedido) => (
                  <div
                    key={pedido.pedido_id}
                    onClick={() =>{
                      setShowUser(false)
                      navigate("/pedidostatuslayout", {
                        state: { pedido_id: pedido.pedido_id },
                        
                      })}
                    }
                    style={{
                      background: "#fff",
                      borderRadius: 12,
                      padding: "14px 12px",
                      boxShadow: "0 4px 14px rgba(17,24,39,0.05)",
                      cursor: "pointer",
                      border: "1px solid rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 8,
                        gap: 8,
                      }}
                    >
                      <strong style={{ fontSize: "0.98rem", color: "#111827" }}>
                        Pedido #{pedido.pedido_id}
                      </strong>

                      <span
                        style={{
                          fontSize: "0.78rem",
                          padding: "5px 9px",
                          borderRadius: 999,
                          background:
                            pedido.current_stage === "cancelled"
                              ? "rgba(239,68,68,0.12)"
                              : pedido.current_stage === "delivered"
                                ? "rgba(34,197,94,0.12)"
                                : "rgba(0,0,0,0.06)",
                          color:
                            pedido.current_stage === "cancelled"
                              ? "#dc2626"
                              : pedido.current_stage === "delivered"
                                ? "#16a34a"
                                : "#111827",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {pedido.current_stage === "paid" && "Pagamento confirmado"}
                        {pedido.current_stage === "production_started" && "Produção iniciada"}
                        {pedido.current_stage === "production_completed" && "Produção concluída"}
                        {pedido.current_stage === "separation_started" && "Separação iniciada"}
                        {pedido.current_stage === "separation_completed" && "Separação concluída"}
                        {pedido.current_stage === "shipped" && "Enviado"}
                        {pedido.current_stage === "delivered" && "Entregue"}
                        {pedido.current_stage === "cancelled" && "Cancelado"}
                        {![
                          "paid",
                          "production_started",
                          "production_completed",
                          "separation_started",
                          "separation_completed",
                          "shipped",
                          "delivered",
                          "cancelled",
                        ].includes(pedido.current_stage) && "Aguardando pagamento"}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        color: "#4b5563",
                        fontSize: "0.9rem",
                      }}
                    >
                      <span>
                        <strong>Total:</strong>{" "}
                        R${" "}
                        {Number(pedido.pedido_valor_total || 0).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>

                      <span>
                        <strong>Criado em:</strong>{" "}
                        {pedido.created_at
                          ? new Date(pedido.created_at).toLocaleDateString("pt-BR")
                          : "-"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: "20px 14px",
                  textAlign: "center",
                  color: "#6b7280",
                  boxShadow: "0 4px 14px rgba(17,24,39,0.05)",
                }}
              >
                Nenhum pedido encontrado.
              </div>
            )}
          </>
        ) : (
          <PedidoStatus pedidoId={pedidoSelecionado.pedido_id} />
        )}
      </div>
    </div>
  ) : (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {!pedidoSelecionado ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: 0 }}>Meus Pedidos</h2>
          </div>

          <div
            style={{
              padding: "1rem",
              borderRadius: 12,
              boxShadow: "0 6px 18px rgba(17,24,39,0.04)",
              width: "100%",
              boxSizing: "border-box",
              background: "#fff",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: 920,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              {loadingPedidos ? (
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "16px",
                    borderRadius: 10,
                    color: "#6b7280",
                  }}
                >
                  Carregando pedidos...
                </div>
              ) : erroPedidos ? (
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "16px",
                    borderRadius: 10,
                    color: "red",
                  }}
                >
                  {erroPedidos}
                </div>
              ) : pedidos?.length > 0 ? (
                pedidos.map((pedido) => (
                  <div
                    key={pedido.pedido_id}
                    onClick={() =>{
                      setShowUser(false)
                      navigate("/pedidostatuslayout", {
                        state: { pedido_id: pedido.pedido_id },
                      })
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                      width: "100%",
                      background: "#f8fafc",
                      padding: "14px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      border: "1px solid rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        minWidth: 0,
                      }}
                    >
                      <strong style={{ color: "#111827", fontSize: "0.98rem" }}>
                        Pedido #{pedido.pedido_id}
                      </strong>

                      <span style={{ color: "#4b5563", fontSize: "0.92rem" }}>
                        Total:{" "}
                        <strong>
                          R${" "}
                          {Number(pedido.pedido_valor_total || 0).toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>

                      <span style={{ color: "#6b7280", fontSize: "0.88rem" }}>
                        Criado em{" "}
                        {pedido.created_at
                          ? new Date(pedido.created_at).toLocaleDateString("pt-BR")
                          : "-"}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        minWidth: 180,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.82rem",
                          padding: "6px 10px",
                          borderRadius: 999,
                          background:
                            pedido.current_stage === "cancelled"
                              ? "rgba(239,68,68,0.12)"
                              : pedido.current_stage === "delivered"
                                ? "rgba(34,197,94,0.12)"
                                : "rgba(0,0,0,0.06)",
                          color:
                            pedido.current_stage === "cancelled"
                              ? "#dc2626"
                              : pedido.current_stage === "delivered"
                                ? "#16a34a"
                                : "#111827",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {pedido.current_stage === "paid" && "Pagamento confirmado"}
                        {pedido.current_stage === "production_started" && "Produção iniciada"}
                        {pedido.current_stage === "production_completed" && "Produção concluída"}
                        {pedido.current_stage === "separation_started" && "Separação iniciada"}
                        {pedido.current_stage === "separation_completed" && "Separação concluída"}
                        {pedido.current_stage === "shipped" && "Enviado"}
                        {pedido.current_stage === "delivered" && "Entregue"}
                        {pedido.current_stage === "cancelled" && "Cancelado"}
                        {![
                          "paid",
                          "production_started",
                          "production_completed",
                          "separation_started",
                          "separation_completed",
                          "shipped",
                          "delivered",
                          "cancelled",
                        ].includes(pedido.current_stage) && "Aguardando pagamento"}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "16px",
                    borderRadius: 10,
                    color: "#6b7280",
                  }}
                >
                  Nenhum pedido encontrado.
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 12,
            }}
          >
            <FaArrowLeft
              onClick={() => setPedidoSelecionado(null)}
              style={{ cursor: "pointer" }}
            />
            <h2 style={{ margin: 0 }}>
              Status do Pedido #{pedidoSelecionado.pedido_id}
            </h2>
          </div>

          <PedidoStatus pedidoId={pedidoSelecionado.pedido_id} />
        </div>
      )}
    </div>
  );
}